import Dialog from 'ui/Dialog';
import Icon from 'ui/Icon';
import { useCurrentFormSankeyId } from 'utils/form';

import DiagramsOverview from '../../DiagramsOverview';

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

// TODO: Rename to OpenDiagramDialog
const OpenDiagramModal: React.FC<Props> = ({ open, setOpen }) => {
  const currentSankeyId = useCurrentFormSankeyId();
  return (
    <Dialog.Root
      open={open}
      onOpenChange={(e) => setOpen(e.open)}
      restoreFocus={false}
      trapFocus={false}
      size="xl"
    >
      <Dialog.Content>
        <Dialog.Header>
          <Icon fontSize="md" icon="file-regular" mr={2} /> Open diagram
        </Dialog.Header>
        <Dialog.Body>
          <DiagramsOverview
            currentSankeyId={currentSankeyId}
            onSelect={() => setOpen(false)}
          />
        </Dialog.Body>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default OpenDiagramModal;
